import { render, staticRenderFns } from "./MyWallet.vue?vue&type=template&id=8823291a&scoped=true"
import script from "./MyWallet.vue?vue&type=script&lang=js"
export * from "./MyWallet.vue?vue&type=script&lang=js"
import style0 from "./MyWallet.vue?vue&type=style&index=0&id=8823291a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8823291a",
  null
  
)

export default component.exports